import { createSlice } from "@reduxjs/toolkit";
import { correctNetworkId } from "../../Common/config";

const initialState = {
  proposalData: {},
  proposals: [],
  isMetamask: true,
  currentNetworkId: correctNetworkId,
  loading: false,
  dashboardLoading: true,
  cultData: "",
  customRoute: "/proposalOptions",
  mandersList: [],
  dashboard: {
    cData: {},
    totalStakedAmount: 0,
    totalRVLTstaked: 0,
    cultBurned: 0,
    totalTreasuryBalance: 0,
    totalInvestmentFund: 0,
  },
};

export const proposalSlice = createSlice({
  name: "proposal",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    currentProposal: (state, action) => {
      state.proposalData = action.payload;
    },
    allProposal: (state, action) => {
      state.proposals = action.payload;
    },
    setMetamask: (state, action) => {
      state.isMetamask = action.payload;
    },
    setNetworkId: (state, action) => {
      state.currentNetworkId = action.payload;
    },
    proposalLoading: (state, action) => {
      state.loading = action.payload;
    },
    setDashboardLoading: (state, action) => {
      state.dashboardLoading = action.payload;
    },
    setCultData: (state, action) => {
      state.cultData = action.payload;
    },
    setCustomRoute: (state, action) => {
      state.customRoute = action.payload;
    },
    setDashboard: (state, action) => {
      state.dashboard = action.payload;
    },
    setMandersList: (state, action) => {
      state.mandersList = action.payload;
    },
  },
});

export const {
  currentProposal,
  allProposal,
  setMetamask,
  setNetworkId,
  proposalLoading,
  setCultData,
  setCustomRoute,
  setDashboard,
  setMandersList,
  setDashboardLoading,
} = proposalSlice.actions;

// The function below is called a selector and allows us to select a proposalSlice from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.proposalSlice)`
export const selectProposal = (state) => state.proposal;

// We can also write thunks by hand, which may contain both sync and async logic.
// Here's an example of conditionally dispatching actions based on current state.
// export const incrementIfOdd = (amount) => (dispatch, getState) => {
//   const currentproposalSlice = selectCount(getState());
//   if (currentproposalSlice % 2 === 1) {
//     dispatch(incrementByAmount(amount));
//   }
// };

export default proposalSlice.reducer;
